// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dynamic-content-container{height:100%}.dynamic-content-container img{-webkit-user-drag:none}.dynamic-content-container .dv-audio .dvAudio{margin:0!important}", ""]);
// Exports
module.exports = exports;
